/* eslint-disable react/style-prop-object */
import styled from "styled-components";
import Modal from "../../../components/Modal/Modal";
import { useApp } from "../../../contexts";

const ContentWaper = styled.div`
  max-height: 65vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const TermAndConditionStyled = styled.div`
  div {
    margin-bottom: 30px;
  }
  h4 {
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    letter-spacing: 0%;
    color: #132f41;
    margin-bottom: 10px;
  }

  p,
  ol,
  ul {
    font-weight: 500;
    font-size: 17px;
    line-height: 29.75px;
    letter-spacing: 0%;
    text-align: justify;
    color: #6b6b6b;
  }

  ol {
    list-style: inside;
    list-style-type: decimal;
    padding-inline-start: 10px;
  }

  ul {
    list-style: inside;
    list-style-type: disc;
    padding-inline-start: 20px;
  }
`;

export const ModalTermAndConditionAirwallex = ({ onClose, onSubmit, okLoading }) => {
  const { T } = useApp();

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="850px"
        className={"modal-mint"}
        onClose={onClose}
      >
        <ContentWaper>
          <div className="text-aia-red text-center font-semibold text-[24px] xls:text-[30px] tracking-[-0.96px] lg:h-full">
            {T("term_and_condition_credix_title")}
          </div>
          <div className="mt-[10px] lg:mt-[10px] overflow-y-auto max-h-[50vh]">
            <div>
              <TermAndConditionStyled className="mt-[20px] text-[14px] md:text-[16px] lg:mt-[20px]  justify-center items-center text-black text-base leading-[26px]"
                dangerouslySetInnerHTML={{
                  __html: T("term_and_condition_airwallex")
                }}
              >
              </TermAndConditionStyled>
              <div className="flex gap-3 md:gap-[20px] justify-center flex-col md:flex-row items-center mt-[40px]">
                <button
                  onClick={() => onClose()}
                  disabled={okLoading}
                  className="rounded-[14px] border border-solid px-[16px] min-w-[150px] py-[9px]  w-full sm:w-auto bg-[#fff] text-[#000] text-center text-[14px] md:text-[16px]"
                >
                  {T("Cancel")}
                </button>
                <button
                  onClick={() => onSubmit()}
                  disabled={okLoading}
                  className="rounded-[14px] border border-solid px-[16px] py-[9px] min-w-[150px] w-full sm:w-auto bg-black text-[#fff] text-center text-[14px] md:text-[16px]"
                >
                  {T("Agree")}
                </button>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
